"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { I18nProvider } from "@/components/I18nProvider";
import { ThemeProvider } from "@/components/ThemeProvider";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { PostHogProvider } from "@/components/PostHogProvider";
import { ChatwootWidget } from "@/components/ChatwootWidget";
import { useState } from "react";

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <I18nProvider>
      <PostHogProvider>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider>
            <TooltipProvider>
              {children}
              <Toaster />
              <Sonner />
              <ChatwootWidget />
            </TooltipProvider>
          </ThemeProvider>
        </QueryClientProvider>
      </PostHogProvider>
    </I18nProvider>
  );
}
